"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AttackDetection = void 0;
var resource_1 = __importDefault(require("./resource"));
var AttackDetection = (function (_super) {
    __extends(AttackDetection, _super);
    function AttackDetection(client) {
        var _this = _super.call(this, client, {
            path: '/admin/realms/{realm}/attack-detection/brute-force',
            getUrlParams: function () { return ({
                realm: client.realmName
            }); },
            getBaseUrl: function () { return client.baseUrl; }
        }) || this;
        _this.findOne = _this.makeRequest({
            method: 'GET',
            path: '/users/{id}',
            urlParamKeys: ['id'],
            catchNotFound: true
        });
        _this.del = _this.makeRequest({
            method: 'DELETE',
            path: '/users/{id}',
            urlParamKeys: ['id']
        });
        _this.delAll = _this.makeRequest({
            method: 'DELETE',
            path: '/users'
        });
        return _this;
    }
    return AttackDetection;
}(resource_1["default"]));
exports.AttackDetection = AttackDetection;
//# sourceMappingURL=attackDetection.js.map